// extracted by mini-css-extract-plugin
export default {"breadcrumbWrap":"BreadCrumbs_breadcrumbWrap__u58Av","breadcrumb":"BreadCrumbs_breadcrumb__oI44y"};